import { HttpClient } from '@placer-ui/http-client';

export const httpClient = new HttpClient({
    baseUrl: process.env.REACT_APP_API_ENDPOINT!,
});
